// extracted by mini-css-extract-plugin
module.exports = {"canvas":"QrCode_canvas__xToji","root":"QrCode_root__SCixg"};